/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any) => ({
    // 모델 조회
    async index(data?: any) {
        return camelize(
            await $axios.get(`/model`, snakelize({ params: data }))
        );
    },

    async toggleReject(data?: any) {
        return camelize(
            await $axios.post(`/model/${data.userId}/reject`, snakelize(data))
        );
    },

    async toggleSupport(data?: any) {
        return camelize(
            await $axios.post(`/model/${data.userId}/support`, snakelize(data))
        );
    },
});
